import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {CouponType} from '../../data/coupon-type';
import {Store} from '@softline/core';
import {BackNavigable, BackNavigationService} from '@softline/application';
import {SOFTLINE_FEATURE_COUPON} from '../../coupon-app.shared';
import {CouponStore} from '../../store/coupon.store';
import {CommonModule} from '@angular/common';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-existing-start',
    imports: [CommonModule,
    TranslatePipe],
    templateUrl: './existing-start.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./existing-start.component.css']
})
export class ExistingStartComponent implements OnInit, OnDestroy, BackNavigable {

  coupon$: Observable<CouponType> = this.store.observe(SOFTLINE_FEATURE_COUPON, CouponStore.getters.data);

  constructor(protected router: Router,
              private store: Store,
              private backNavigationService: BackNavigationService) {}

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
    const entity = this.store.get(SOFTLINE_FEATURE_COUPON, CouponStore.getters.data);
    if (!entity) {
      await this.router.navigate(['/gutscheinkarten']);
      return;
    }
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/gutscheinkarten']);
  }

  async navigateTo(destination: 'charge' | 'redeem'): Promise<void> {
    await this.router.navigate([`/gutscheinkarten/${destination}`], destination === 'charge' ? {queryParams: { mode: 'existing' }} : {});
  }

  async cancel(): Promise<void> {
    await this.router.navigate(['/gutscheinkarten']);
  }
}
